import React from "react";
import { Check } from "lucide-react";

const FEATURE_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/5b87ecfc-f8ae-4dd8-bcf3-9a9f8d13bb45/images/15763a46f0bd9d6eff140f873a0f14ad436b36ebba2351701a09f12e067c5074.png";

const points = [
  "Anspruch ab Pflegegrad 1 – ohne Mehrkosten",
  "Monatliche Lieferung diskret nach Hause",
  "Individuell nach Bedarf zusammengestellt",
  "Direkte Abrechnung mit der Pflegekasse",
];

export const WasIst = () => {
  return (
    <section
      id="was-ist"
      data-testid="was-ist-section"
      className="relative py-24 sm:py-32 bg-[#FAFAF7]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[#3FA66D] mb-5">
              Was ist die Pflegebox
            </div>
            <h2
              data-testid="was-ist-headline"
              className="text-4xl sm:text-5xl font-medium leading-tight text-[#1A1A1F]"
            >
              <span className="text-gradient-dark">Hilfsmittel,</span>{" "}
              <span>die wirklich</span>{" "}
              <span className="text-gradient-green">helfen.</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg text-[#5A5F66] leading-relaxed">
              Pflegende Angehörige haben einen gesetzlichen Anspruch auf
              kostenfreie Pflegehilfsmittel zum Verbrauch – im Wert von bis zu
              42&nbsp;€ monatlich. Wir kümmern uns um Antrag, Auswahl und
              Lieferung. Sie konzentrieren sich auf das, was wirklich zählt.
            </p>

            <ul className="mt-8 space-y-4">
              {points.map((p) => (
                <li
                  key={p}
                  data-testid={`was-ist-point-${p}`}
                  className="flex items-start gap-3 text-[#1A1A1F]/85"
                >
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#3FA66D]/15 border border-[#3FA66D]/40">
                    <Check size={12} className="text-[#3FA66D]" />
                  </span>
                  <span className="text-base">{p}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="absolute -inset-12 bg-[radial-gradient(circle_at_center,_rgba(63,166,109,0.18),_transparent_60%)] blur-2xl pointer-events-none" />
            <div className="relative rounded-[32px] overflow-hidden glass-mint p-8 sm:p-10 animate-float shadow-[0_24px_60px_-20px_rgba(63,166,109,0.25)]">
              <img
                src={FEATURE_IMAGE}
                alt="Pflegebox Hilfsmittel"
                className="w-full h-auto rounded-2xl"
              />
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5A5F66]">
                    Monatlicher Wert
                  </div>
                  <div className="text-3xl font-medium text-[#1A1A1F] mt-1">
                    bis 42 €
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5A5F66]">
                    Ihr Anteil
                  </div>
                  <div className="text-3xl font-medium text-[#3FA66D] mt-1">
                    0 €
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WasIst;
